// extracted by mini-css-extract-plugin
export default {"deadlineBubble":"bubbles_deadlineBubble__-mzUv"};